import { useEffect, useState } from "react";
import API from "../services/api";
import "./plans.css";

export default function Plans() {
  const [plans, setPlans] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    price_per_student: "",
    featuresText: "",
  });

  const loadPlans = async () => {
    const res = await API.get("/plans/");
    setPlans(res.data.plans);
  };

  useEffect(() => {
    loadPlans();
  }, []);

  // =============================
  // DELETE
  // =============================
  const deletePlan = async (id) => {
    if (!window.confirm("Are you sure you want to delete this plan?")) return;

    try {
      await API.delete(`/plans/delete/${id}/`);
      loadPlans();
    } catch (err) {
      alert("Error deleting plan");
    }
  };

  // =============================
  // START EDIT
  // =============================
  const startEdit = (plan) => {
    setEditingId(plan.id);
    setEditForm({
      name: plan.name,
      price_per_student: plan.price_per_student,
      featuresText: plan.features?.join("\n") || "",
    });
  };

  // =============================
  // CANCEL EDIT
  // =============================
  const cancelEdit = () => {
    setEditingId(null);
  };

  // =============================
  // SAVE EDIT
  // =============================
  const saveEdit = async (id) => {
    try {
      const featuresArray = editForm.featuresText
        .split("\n")
        .map((f) => f.trim())
        .filter((f) => f.length > 0);

      await API.put(`/plans/${id}/update/`, {
        name: editForm.name,
        price_per_student: editForm.price_per_student,
        features: featuresArray,
      });

      setEditingId(null);
      loadPlans();
    } catch (err) {
      alert("Update failed");
    }
  };

  return (
    <div className="plans-container">
      {/* HEADER */}
      <div className="plans-header">
        <div>
          <span className="page-kicker">Subscription Plans</span>
          <h2>All Plans</h2>
          <p>Control monthly pricing and feature access for every school tenant.</p>
        </div>
        <a href="/plans/add" className="btn-primary">
          + Add New Plan
        </a>
      </div>

      <div className="plans-summary-grid">
        <div className="plans-summary-card">
          <span>Total Plans</span>
          <strong>{plans.length}</strong>
        </div>
        <div className="plans-summary-card">
          <span>Lowest Price</span>
          <strong>
            ₹{plans.length ? Math.min(...plans.map((p) => Number(p.price_per_student || 0))) : 0}
          </strong>
        </div>
        <div className="plans-summary-card">
          <span>Highest Price</span>
          <strong>
            ₹{plans.length ? Math.max(...plans.map((p) => Number(p.price_per_student || 0))) : 0}
          </strong>
        </div>
      </div>

      {/* TABLE */}
      <div className="plans-table-wrapper">
        <table className="plans-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Plan Name</th>
              <th>Price / Student</th>
              <th>Features</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {plans.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No plans found
                </td>
              </tr>
            ) : (
              plans.map((p, index) => (
                <tr key={p.id}>
                  {/* Sequential ID */}
                  <td>{index + 1}</td>

                  {/* EDIT MODE */}
                  {editingId === p.id ? (
                    <>
                      <td>
                        <input
                          className="edit-input"
                          value={editForm.name}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              name: e.target.value,
                            })
                          }
                        />
                      </td>

                      <td>
                        <input
                          className="edit-input"
                          value={editForm.price_per_student}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              price_per_student: e.target.value,
                            })
                          }
                        />
                      </td>

                      <td>
                        <textarea
                          className="edit-textarea"
                          value={editForm.featuresText}
                          onChange={(e) =>
                            setEditForm({
                              ...editForm,
                              featuresText: e.target.value,
                            })
                          }
                          rows={4}
                        />
                      </td>

                      <td>
                        <button
                          className="btn-save"
                          onClick={() => saveEdit(p.id)}
                        >
                          Save
                        </button>

                        <button
                          className="btn-cancel"
                          onClick={cancelEdit}
                        >
                          Cancel
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="plan-name">{p.name}</td>
                      <td>₹{p.price_per_student}</td>

                      <td>
                        <ul className="features-list">
                          {p.features?.map((f, i) => (
                            <li key={i}>• {f}</li>
                          ))}
                        </ul>
                      </td>

                      <td>
                        <button
                          className="btn-edit"
                          onClick={() => startEdit(p)}
                        >
                          Edit
                        </button>

                        <button
                          className="btn-delete"
                          onClick={() => deletePlan(p.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
